import { NamedRoutes } from "./NamedRoutes";
export class AcceptInviteViewModel {
    constructor(container) {
        this.routingUIManager = container.routingUIManager;
        this.acceptInviteManager = container.acceptInviteManager;
        this.acceptInviteManager.setInviteStatus(true);
        this.routingUIManager.navigateTo(NamedRoutes.INDEX);
    }
}
